module.exports = __webpack_public_path__ + "img/1.724a48a5.jpg";